var baseStyle = {
  paddingY: 8,
  paddingX: 16,
  maxWidth: 240,
  borderRadius: 'radii.2',
  elevation: 'shadows.3'
};
var appearances = {
  card: {
    backgroundColor: 'white'
  },
  "default": {
    color: 'white',
    backgroundColor: 'colors.gray800'
  }
};
var sizes = {};
export default {
  baseStyle: baseStyle,
  appearances: appearances,
  sizes: sizes
};